'use client';
import { useUserService } from './useUserService';

export const useUser = () => {
  const { useGetCookieUser } = useUserService();
  const { data: user } = useGetCookieUser();
  const isAuthenticated = Boolean(user);
  return { isAuthenticated, user };
};
